import { Link } from 'react-router'

import type { ChatCard } from '../../lib/assistant'
import { cardTarget } from '../../lib/assistantRoute'
import { Tier } from '../ui'

/**
 * A measure card under a reply (agent-1-web W3): the card snapshot the server
 * attached (C21) -- its screen heading, its evidence tier and its precaution,
 * all verbatim -- and a link to the full card where the reading lives.
 *
 * The web adds nothing to it: no summary, no colour for the value, no sentence
 * of its own. The tier badge is the cards' own (`Tier`, worded as `ScoreCard`
 * words it), so the drawer and the page say "moderate evidence" alike.
 */
export function EvidenceCard({ card }: { card: ChatCard }) {
  const target = cardTarget(card)
  return (
    <article className="assistant-card" aria-label={card.title}>
      <div className="assistant-card__head">
        <h3 className="assistant-card__title">{card.title}</h3>
        <Tier level={card.evidence_tier}>{card.evidence_tier} evidence</Tier>
      </div>
      <p className="assistant-card__precaution">
        <span className="assistant-card__label">Precaution · </span>
        {card.precaution}
      </p>
      {target ? (
        <Link className="assistant-card__link" to={target.href}>{target.label}</Link>
      ) : (
        <span className="assistant-card__link" aria-disabled="true">Source recording unavailable</span>
      )}
    </article>
  )
}
